// src/pages/tests/questions/Input.tsx  (or wherever it lives)
import React from 'react';
import { InputQuestion } from '../types.ts';
import { ExplanationEditor } from '@huoncroll/math-editors';
import SharedMathLiveEditor from '../../../components/SharedMathLiveEditor.tsx';
import './Input.module.css';

type Props = {
  question: InputQuestion;
  value: string;
  onChange: (s: string) => void;
  unit?: string | null;
  useRichTextEditor?: boolean;
};

const QuestionInput: React.FC<Props> = ({
  value,
  onChange,
  unit,
  useRichTextEditor = false,
}) => {
  const trimmedUnit = (unit ?? '').trim();

  const shellStyle: React.CSSProperties = {
    display: useRichTextEditor ? 'flex' : 'inline-flex',
    alignItems: useRichTextEditor ? 'stretch' : 'center',
    gap: '0.75rem',
    margin: '1rem 0',
    flexWrap: useRichTextEditor ? 'wrap' : 'nowrap',
    width: useRichTextEditor ? '100%' : 'fit-content',
    maxWidth: '100%',
    minWidth: 0,
  };

  const editorWrapperStyle: React.CSSProperties = {
    minWidth: useRichTextEditor ? '100%' : 220,
    maxWidth: useRichTextEditor ? '100%' : 'min(100%, 640px)',
    flex: useRichTextEditor ? '1 1 100%' : '0 1 auto',
    minHeight: 1,
  };

  const unitStyle: React.CSSProperties = {
    fontSize: '0.95rem',
    color: '#334155',
    whiteSpace: 'nowrap',
  };

  return (
    <div style={shellStyle} data-disable-next-shortcut="true">
      <div style={editorWrapperStyle}>
        {useRichTextEditor ? (
          <ExplanationEditor
            value={value}
            onChange={onChange}
            placeholder="Write your response..."
            toolbarMode="studentSimple"
            minHeightPx={160}
            maxHeightPx={360}
          />
        ) : (
          <SharedMathLiveEditor
            value={value}
            onChange={onChange}
            minHeightPx={48}
            maxHeightPx={110}
            minWidthPx={220}
            minWidthPercent={45}
          />
        )}
      </div>

      {!useRichTextEditor && trimmedUnit && <span style={unitStyle}>{trimmedUnit}</span>}
    </div>
  );
};

export default QuestionInput;
